import { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { FaHandsClapping } from "react-icons/fa6";
import makePutRequest from "../utils/makePutRequest";
import PopUpModulBtn from "../PopUpModulBtn";

const LikeSection = ({ likes }) => {
  const likesData =
    typeof likes === "number"
      ? { count: likes, user_has_liked: false }
      : likes || {};

  const [counter, setCounter] = useState(likesData.count || 0);
  const [hasLiked, setHasLiked] = useState(likesData.user_has_liked || false);
  const token = useSelector((state) => state.token);

  const canPersistLike =
    likesData.object_id != null && likesData.object_type != null;

  const handleLikeClick = async () => {
    const newHasLiked = !hasLiked;
    const newCounter = hasLiked ? counter - 1 : counter + 1;
    const action = newHasLiked ? "like" : "unlike";

    setCounter(newCounter);
    setHasLiked(newHasLiked);

    if (canPersistLike) {
      const { error } = await upDateLikesOnServer(action);
      if (error) {
        console.error(
          `[LikeSection] Misslyckades att spara ${action} för ${likesData.object_type} id=${likesData.object_id}: ${error}`
        );
        setCounter(counter);
        setHasLiked(hasLiked);
      }
    }
  };

  const upDateLikesOnServer = (action) => {
    const data = {
      object_id: likesData.object_id,
      object_type: likesData.object_type,
      action: action,
    };
    return makePutRequest("like_action", data);
  };

  if (token) {
    return (
      <div className="mt-4 mb-2 pt-4 flex items-center gap-2">
        <button
          onClick={handleLikeClick}
          className={`btn btn-sm gap-2 ${
            hasLiked ? "btn-neutral text-white" : "btn-outline border-base-content/20"
          }`}
        >
          <FaHandsClapping size={16} />
          {hasLiked ? "Applåderat" : "Ge applåd"}
        </button>
        {counter > 0 && (
          <span className="text-xs font-bold bg-base-300 text-base-content/70 px-2 py-1 rounded-full">
            {counter}
          </span>
        )}
      </div>
    );
  } else {
    return (
      <div className="mt-4 mb-2 pt-4 flex items-center gap-2">
        <PopUpModulBtn
          btnText={
            <span className="flex items-center gap-2">
              <FaHandsClapping size={16} />
              Ge applåd
            </span>
          }
          btnStyle="btn-sm btn-outline border-base-content/20"
          modalId="like"
          title="Logga in för att ge en applåd"
          text="För att kunna ge en applåd behöver du vara inloggad. Logga in eller skapa ett konto för att fortsätta."
        >
          <div className="flex justify-center gap-4">
            <a href="/login">
              <button className="btn btn-primary border border-base-content/20">
                Logga in
              </button>
            </a>
            <a href="/register">
              <button className="btn btn-secondary border border-base-content/20">
                Skapa konto
              </button>
            </a>
          </div>
        </PopUpModulBtn>
        {counter > 0 && (
          <span className="text-xs font-bold bg-base-300 text-base-content/70 px-2 py-1 rounded-full">
            {counter}
          </span>
        )}
      </div>
    );
  }
};

LikeSection.propTypes = {
  likes: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      count: PropTypes.number,
      user_has_liked: PropTypes.bool,
      object_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      object_type: PropTypes.string,
    }),
  ]),
};

export default LikeSection;
